// assets/stamp-gallery.js
// Renders the "Browse designs" template gallery: a filterable grid of the
// shared starter designs, plus "Upload your own" and "Start blank" tiles. Each
// design links to the stamp studio with ?template=<id>, which the studio's
// embedded editor reads to preload that design. Plain module (no Component
// needed).
import { STAMP_TEMPLATES, buildStampThumbSVG } from '@theme/stamp-templates';

const SHAPES = [
  ['all', 'All shapes'],
  ['round', 'Round'],
  ['rectangle', 'Rectangle'],
  ['for', '“For” stamps'],
];
const INKS = [
  ['all', 'All ink'],
  ['Black', 'Black'],
  ['Blue', 'Blue'],
  ['Red', 'Red'],
];

function withParam(url, kv) {
  return url + (url.includes('?') ? '&' : '?') + kv;
}

function build(root) {
  if (root.dataset.galleryInit === 'true') return;
  root.dataset.galleryInit = 'true';

  const studioUrl = root.dataset.studioUrl || '/pages/stamp-studio';
  const grid = root.querySelector('[data-grid]');
  const filtersEl = root.querySelector('[data-filters]');
  if (!grid || !filtersEl) return;

  const state = { shape: 'all', ink: 'all' };

  const chip = (group, val, label, active) =>
    `<button type="button" class="stamp-templates__chip${active ? ' is-active' : ''}" data-group="${group}" data-val="${val}">${label}</button>`;

  filtersEl.innerHTML =
    '<div class="stamp-templates__filter-row" role="group" aria-label="Filter by shape">' +
    SHAPES.map(([v, l]) => chip('shape', v, l, v === 'all')).join('') +
    '</div>' +
    '<div class="stamp-templates__filter-row" role="group" aria-label="Filter by ink">' +
    INKS.map(([v, l]) => chip('ink', v, l, v === 'all')).join('') +
    '</div>';

  filtersEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-group]');
    if (!b) return;
    const grp = b.dataset.group;
    state[grp] = b.dataset.val;
    filtersEl.querySelectorAll(`[data-group="${grp}"]`).forEach((x) => x.classList.toggle('is-active', x === b));
    applyFilter();
  });

  const uploadTile =
    `<a class="stamp-templates__card stamp-templates__card--special" href="${withParam(studioUrl, 'mode=upload')}" data-shape="all" data-ink="all">` +
    '<span class="stamp-templates__thumb stamp-templates__thumb--icon" aria-hidden="true">&#8593;</span>' +
    '<span class="stamp-templates__name">Upload your own design</span></a>';
  const blankTile =
    `<a class="stamp-templates__card stamp-templates__card--special" href="${studioUrl}" data-shape="all" data-ink="all">` +
    '<span class="stamp-templates__thumb stamp-templates__thumb--icon" aria-hidden="true">&#43;</span>' +
    '<span class="stamp-templates__name">Start from blank</span></a>';

  const cards = STAMP_TEMPLATES.map((t) => {
    const href = withParam(studioUrl, 'template=' + encodeURIComponent(t.id));
    return (
      `<a class="stamp-templates__card" href="${href}" data-shape="${t.shape}" data-ink="${t.ink}">` +
      `<span class="stamp-templates__thumb">${buildStampThumbSVG(t)}</span>` +
      `<span class="stamp-templates__name">${t.name}</span></a>`
    );
  }).join('');

  grid.innerHTML = uploadTile + blankTile + cards;

  function applyFilter() {
    grid.querySelectorAll('.stamp-templates__card').forEach((card) => {
      const special = card.classList.contains('stamp-templates__card--special');
      const okShape = state.shape === 'all' || special || card.dataset.shape === state.shape;
      const okInk = state.ink === 'all' || special || card.dataset.ink === state.ink;
      card.hidden = !(okShape && okInk);
    });
  }
}

function boot() {
  document.querySelectorAll('[data-stamp-gallery]').forEach(build);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

document.addEventListener('shopify:section:load', (e) => {
  const r = e.target.querySelector ? e.target.querySelector('[data-stamp-gallery]') : null;
  if (r) build(r);
});
